import React from 'react';
import { formatAbsoluteFa, formatRelativeFa } from '../../../shared/utils/relativeTime';
import { getPersianDateFromGregorian } from '../../../shared/utils/persianDate';
import { localizeDigits } from '../../../shared/utils/numberLocale';
import { useLastCalcDate } from '../hooks/useLastCalcDate';

function compactCalcLabel(input) {
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return null;
  const days = (Date.now() - date.getTime()) / 86400000;
  if (days >= 0 && days < 7) return formatRelativeFa(input);
  const { year, month, day } = getPersianDateFromGregorian(date);
  return localizeDigits(`${year}/${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}`);
}

export default function CalcTimeChip({ className = '' }) {
  const { data: lastCalc } = useLastCalcDate();
  if (!lastCalc) return null;
  const relative = compactCalcLabel(lastCalc);
  const absolute = formatAbsoluteFa(lastCalc);
  if (!relative) return null;

  return (
    <span
      title={absolute || undefined}
      className={`inline-flex h-6 items-center gap-1 rounded-full bg-emerald-50 px-2 text-[10px] font-bold text-emerald-800 ring-1 ring-emerald-200/80 ${className}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500" />
      </span>
      <span className="text-emerald-600/80 font-semibold">محاسبه</span>
      <span className="tabular-nums">{relative}</span>
    </span>
  );
}
